import { ArrowRight } from "lucide-react";

import styles from "./PendingProductReview.module.scss";

const SimilarProductItem = ({ item, allAptitudesLocal, allActiveIngredientsLocal, changeProduct }) => {
	const aptitudes = allAptitudesLocal?.filter((aptitude) => item.aptitudes?.some((_itemAptitude) => item.aptitudes.includes(aptitude.value))) || [];

	const activeIngredients =
		allActiveIngredientsLocal?.filter((ingredient) =>
			item.active_ingredients?.some((_itemIngredient) => item.active_ingredients.includes(ingredient.value)),
		) || [];

	return (
		<div className={styles.similarItem}>
			<div>
				<strong>{item?.label}</strong>
			</div>
			<p>{aptitudes.length > 0 ? `${aptitudes.map((aptitude) => aptitude.label).join(", ")}` : ""}</p>
			<p>{activeIngredients.length > 0 ? `${activeIngredients.map((ingredient) => ingredient.label).join(", ")}` : ""}</p>
			<button className={styles.useBtn} onClick={() => changeProduct(item)}>
				<ArrowRight size={14} />
				Usar
			</button>
		</div>
	);
};

export default SimilarProductItem;
